import { createAction } from 'redux-actions';

export const callApiGetInformationXPAND = createAction('CALL_API_GET_INFORMATION_XPAND_ORGANIZER');
export const callApiGetInformationXPANDReceived = createAction('CALL_API_GET_INFORMATION_XPAND_RECEIVED');
export const callApiGetInformationXPANDReceivedFailure = createAction('CALL_API_GET_INFORMATION_XPAND_RECEIVED_FAILURE');
export const clearGetInfomationData = createAction('CLEAR_GET_INFOMATION_DATA');

export const callApiCreateOrganizer = createAction('CALL_API_CREATE_ORGANIZER');
export const callApiCreateOrganizerReceived = createAction('CALL_API_GET_CREATE_RECEIVED');
export const callApiCreateOrganizerReceivedFailure = createAction('CALL_API_GET_CREATE_RECEIVED_FAILURE');
export const clearCreateOrganizer = createAction('CALL_API_CLEAR_CREATE_ORGANIZER');

export const callApiGetInformationRoom = createAction('CALL_API_GET_INFORMATION_ROOM');
export const callApiGetInformationRoomReceived = createAction('CALL_API_GET_INFORMATION_ROOM_RECEIVED');
export const callApiGetInformationRoomReceivedFailure = createAction('CALL_API_GET_INFORMATION_ROOM_RECEIVED_FAILURE');
